export default __webpack_public_path__ + "static/media/tick.9a582a4f.svg";